import type { LoginModalType } from 'types';

import AppleIcon from '~/assets/icons/Apple';
import useRegion from '~/hooks/useRegion';

import Tracked from '../../Tracked';

const appsFlyerSignUpModalLink =
  'https://thesolesupplier.onelink.me/BPkz/a936f1fo';

const DownloadAppFooter = ({ modalType }: { modalType?: LoginModalType }) => {
  const region = useRegion();

  if (region.code !== 'GB') return null;

  return (
    <div className="pt-2">
      <h3 className="py-4 text-center font-normal text-black">
        {modalType === 'notifications'
          ? 'Get instant push notifications with the app:'
          : 'Or download our app to get signed in:'}
      </h3>
      <Tracked.ExternalLink
        name="DOWNLOAD_THE_APP"
        pagePosition={'Modal'}
        href={appsFlyerSignUpModalLink}
        target="_blank"
        rel="noreferrer"
        variant="none"
        className="flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-black font-semibold text-white"
      >
        <AppleIcon colour="white" />
        <span>Download the iOS app</span>
      </Tracked.ExternalLink>
    </div>
  );
};

export default DownloadAppFooter;
